<script lang="ts">
import SettingsBox from '../../elements/SettingsBox.svelte';
import Title from "../../elements/settings/Title.svelte";
import TitleIcon from "../../elements/settings/TitleIcon.svelte";
import PrimaryBox from "../../elements/settings/PrimaryBox.svelte";
import Booleans from "../../elements/settings/Buttons/Booleans.svelte";
import { blink } from '../../../stores/storedSettings';
import anime from 'animejs';
import { cbDefault } from '../../../utils/animations';

$: {
    if ($blink) {
        anime({
            targets: '.blick-icon',
            opacity: [0.3, 1],
            duration: 400,
            loop: 5,
            direction: 'alternate',
            easing: cbDefault,
        })
    }
}

</script>

<SettingsBox bordered={false} id="blinking-dots">
    <Title title="闪烁分隔符">
        <TitleIcon>
            <i class="lnr blick-icon lnr-eye text-primary settings-title-icon" class:opacityy-30={!$blink}></i>
        </TitleIcon>
    </Title>
    <PrimaryBox 
        label={{text: '让分隔符有节奏地跳动'}} 
        description={{text:'如果你觉得它们分散注意力，可以让分隔符保持静止', iconClass: 'lnr lnr-question-circle'}}
        available={true}
    >
        <Booleans state={$blink} label={'闪烁'} on:change={(e) => blink.set(e.detail)}/>
    </PrimaryBox>
</SettingsBox>

<style>
    .opacityy-30 {
        opacity: 0.3 !important;
    }
</style>